import './SnoozeIssueButton.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import dayjs from 'dayjs';
import { haltClickEventPropagation } from '@lib/events';
import { issuesActions } from '@sonar-software/sonar-issues';
import { PopoverMenuButton } from '@ui/menu';
import { useAction } from '@hooks';
import { ArrowLeftOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker } from 'antd';
import { getClosestCardHeader, getDirectParent } from '@lib/popups';
import React, { useCallback, useMemo, useState } from 'react';
function getRegularMenuItems(sonarObjectId, setShowDatepicker, handleDateSelection) {
    const todayMorning = dayjs().startOf('day')
        .add(9, 'hours');
    const tomorrowDate = todayMorning.clone().add(1, 'days');
    const nextWeekDate = todayMorning.clone().add(1, 'weeks');
    const oneMonthDate = todayMorning.clone().add(1, 'months');
    const menuItems = [
        {
            key: COPY_SPECIFIC.TOMORROW,
            label: React.createElement(React.Fragment, null,
                React.createElement("span", null, COPY_SPECIFIC.TOMORROW),
                React.createElement("span", null, tomorrowDate.format('dddd'))),
            onClick: (e) => {
                e.domEvent.stopPropagation();
                handleDateSelection(tomorrowDate.toISOString());
            }
        },
        {
            key: COPY_SPECIFIC.NEXT_WEEK,
            label: React.createElement(React.Fragment, null,
                React.createElement("span", null, COPY_SPECIFIC.NEXT_WEEK),
                React.createElement("span", null, nextWeekDate.format('dddd'))),
            onClick: (e) => {
                e.domEvent.stopPropagation();
                handleDateSelection(nextWeekDate.toISOString());
            }
        },
        {
            key: COPY_SPECIFIC.ONE_MONTH,
            label: React.createElement(React.Fragment, null,
                React.createElement("span", null, COPY_SPECIFIC.ONE_MONTH),
                React.createElement("span", null, oneMonthDate.format('dddd, MMMM Do'))),
            onClick: (e) => {
                e.domEvent.stopPropagation();
                handleDateSelection(oneMonthDate.toISOString());
            }
        },
        {
            type: 'divider'
        },
        {
            key: 'select-date',
            label: React.createElement(Button, { icon: React.createElement(ClockCircleOutlined, null), id: `snooze-select-date-issue-${sonarObjectId}`, onClick: (e) => {
                    e.stopPropagation();
                    setShowDatepicker(true);
                }, type: 'default' }, COPY_SPECIFIC.SELECT_DATE)
        }
    ];
    return menuItems;
}
function getSecondaryMenuItems(sonarObjectId, setShowDatepicker, handleDateSelection) {
    const today = dayjs().endOf('day');
    const menuItems = [
        {
            key: 'back',
            label: React.createElement(Button, { className: 'snooze-back-button', icon: React.createElement(ArrowLeftOutlined, null), id: `snooze-back-issue-${sonarObjectId}`, onClick: (e) => {
                    e.stopPropagation();
                    setShowDatepicker(false);
                }, type: 'link' }, COPY_SPECIFIC.BACK)
        },
        {
            type: 'divider'
        },
        {
            className: 'snooze-issue-calendar',
            key: 'calendar',
            label: React.createElement(DatePicker, { defaultOpen: true, disabledDate: (currentDate) => currentDate < today, getPopupContainer: getDirectParent, onChange: (value) => value && handleDateSelection(value.startOf('day').add(9, 'hours')
                    .toISOString()), onClick: haltClickEventPropagation, open: true, showTime: false })
        }
    ];
    return menuItems;
}
export const SnoozeIssueButton = ({ sonarObjectId }) => {
    const [showDatepicker, setShowDatepicker] = useState(false);
    const archiveOrSnoozeIssue = useAction(issuesActions.requestPostIssuesByIdVisibility);
    const handleDateSelection = useCallback((date) => {
        archiveOrSnoozeIssue({
            snoozeUntil: date,
            sonarObjectId
        });
    }, [archiveOrSnoozeIssue, sonarObjectId]);
    const handleOpenChange = useCallback((value) => {
        if (!value) {
            setTimeout(() => setShowDatepicker(false), 250);
        }
    }, []);
    const menuItems = useMemo(() => {
        if (showDatepicker) {
            return getSecondaryMenuItems(sonarObjectId, setShowDatepicker, handleDateSelection);
        }
        return getRegularMenuItems(sonarObjectId, setShowDatepicker, handleDateSelection);
    }, [sonarObjectId, showDatepicker, handleDateSelection]);
    const overlayClassNames = classNames('snooze-issue-menu', { 'snooze-options': !showDatepicker });
    return (React.createElement(PopoverMenuButton, { getPopupContainer: getClosestCardHeader, icon: React.createElement(ClockCircleOutlined, null), id: `snooze-issue-${sonarObjectId}`, menuItems: menuItems, onClick: haltClickEventPropagation, onOpenChange: handleOpenChange, overlayClassName: overlayClassNames }, COPY_SPECIFIC.SNOOZE));
};
